import { enqueueSnackbar } from 'notistack'

import AddIcon from '@mui/icons-material/Add'
import { ddeApi } from '@/service/ddeApi'
import { StandarizedGolfPlayer } from '@/views/DataAdmin/types'

import { ActionMenuDialogItem } from '../ActionMenuDialogItem/ActionMenuDialogItem'
import { useActionMenuContext } from '../context/ActionMenuContext'
import { MenuItemLike } from '../index.types'

export const makeConfirmationMessage = (player: StandarizedGolfPlayer) =>
  `You're about to add player ${player.displayName} from the quarantine.`

type Props = MenuItemLike & {
  onSubmit?: () => void
  setLoading?: (isLoading: boolean) => void
}

export const ActionAddQuarantine = ({ onSubmit, setLoading, displaySeparately }: Props) => {
  const { row: quarantinePlayer } = useActionMenuContext<StandarizedGolfPlayer>()
  const golfEndpoints = ddeApi.endpoints.golf

  const handleSubmit = async () => {
    setLoading?.(true)

    golfEndpoints.quarantine
      .addPlayer(quarantinePlayer.id)
      .then(() => {
        enqueueSnackbar(`Player ${quarantinePlayer.displayName} added successfully.`, {
          variant: 'success',
          autoHideDuration: 2000,
          anchorOrigin: { horizontal: 'left', vertical: 'bottom' }
        })
      })
      .catch(() => {
        enqueueSnackbar(`Error while adding player ${quarantinePlayer.displayName}.`, {
          variant: 'error',
          autoHideDuration: 2000,
          anchorOrigin: { horizontal: 'left', vertical: 'bottom' }
        })
      })
      .finally(() => {
        onSubmit?.()
        setLoading?.(false)
      })
  }

  const insertDisabled = !(
    quarantinePlayer.etId ||
    quarantinePlayer.livId ||
    quarantinePlayer.lpgaId ||
    quarantinePlayer.pgaId
  )

  return (
    <>
      <ActionMenuDialogItem
        disableSnackbar={{
          successDisabled: true,
          errorDisabled: true
        }}
        disabled={insertDisabled}
        label="Add"
        icon={() => <AddIcon />}
        onClick={handleSubmit}
        displaySeparately={displaySeparately}
        overrideText="Add player"
        successMessage={() => ''}
        confirmationMessage={makeConfirmationMessage(quarantinePlayer)}
      />
    </>
  )
}
